import React from 'react'
import renderContent from '../../utilities/renderContent'
import { Parallax } from 'react-parallax';
import { List, ListItem } from 'material-ui/List'
import Subheader from 'material-ui/Subheader'
import Divider from 'material-ui/Divider'
import { Link } from 'react-router-dom'

import './style.css'

class TestList extends React.PureComponent {
  render() {
    const {
      tests,
    } = this.props

    return (
      <div className="tests">
        <div className="container">
          <h1 className="title">Tests</h1>
          <div className="list-wrapper">
            <List>
              {Object.keys(tests).map((key, index) => {
                const test = tests[key]

                return (
                  <Link to={`/tests/${key}`} key={index}>
                    <ListItem
                      primaryText={test.name}
                    />
                  </Link>
                )
              })}
            </List>
          </div>
        </div>
      </div>
    )
  }
}

const Test = ({ tests }) => {
  console.log('Tests.tests', tests)
  var image_dom = null;
  if (tests.images != undefined){
    image_dom = tests.images.map(function(image, key){
        return (
          <img src={image}
            className="image-treatment"
            draggable="false"
            alt={tests.name}
            key={key}
          />
        )
      }
    )
  }
  return (
    <div className="treatment">
      <div className="page-bg">
        {/* treatment.images[0] */}
        <Parallax bgImage="../images/tests/00.jpg" strength={150} className="page-parallax">
        </Parallax>
      </div>
      <div className="container container-parallax">
        <div className="parallax-container">
          <div className="content">
            <div className="left">
              {image_dom}
            </div>
            <div className="right">
              <div className="treatment-title">{tests.name}</div>
              {renderContent(tests.content)}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

const Tests = ({ data, match }) => {
  if (match && match.params.testId !== undefined && data.tests[match.params.testId] !== undefined) {
    return <Test tests={data.tests[match.params.testId]} />
  } else {
    return <TestList tests={data.tests} />
  }
}

export default Tests



// WEBPACK FOOTER //
// ./src/components/Tests/index.js